export const SENTRY_DSN = 'https://11d504eac4cd51e98d8de016ef2a9b95@sentry.ituchong.com/34';
